import { ReportIncidentDetail } from "fleet/controller/report-incident-detail";
import { FETCH_INCIDENT_DETAIL_REPORT } from "fleet/redux-store/ui-state/report-incident/actions";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import * as Auth from "redux-store/auth/selectors";

function mapStateToProps(state, props) {
  const auth = Auth.authSelector(state);
  const authenticated = Auth.isAuthenticated(auth);
  const { jwtToken } = props.match.params || {};

  return {
    authenticated,
    jwtToken,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchIncidentDetailReport: (jwtToken) => {
      return createPromiseApiAction(dispatch, FETCH_INCIDENT_DETAIL_REPORT, [
        jwtToken,
      ]);
    },
  };
}

const ConnectedReportIncidentDetail = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportIncidentDetail);

export { ConnectedReportIncidentDetail };
